import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AttributeType, BooleanType } from '../../../../constants/app-constants';
import { ToggleComponent } from '../../../common/toggle/toggle.component';
import { MultiSelectComponent } from '../../../select/multi-select.component';
import { selectValidator } from '../../../../validators/select-validator';
import { SharedModule } from '../../../../modules/shared/shared.module';
import { Attribute } from '../../../../models/masters/attribute.interface';
import { FinanceApiService } from '../../../../services/finance-a-p-iervice.service';
import { ToasterService } from '../../../../services/toaster.service';
import { firstValueFrom } from 'rxjs';
import { LoadingService } from '../../../../services/loading.service';
@Component({
  selector: 'app-manage-attribute',
  standalone: true,
  imports: [ToggleComponent, MultiSelectComponent, SharedModule],
  templateUrl: './manage-attribute.component.html',
  styleUrl: './manage-attribute.component.scss'
})
export class ManageAttributeComponent {
  attributeForm!: FormGroup;

  @Input() attribute!: Attribute;

  editMode: boolean = false;
  attributeTypeOptions = Object.entries(AttributeType).map(([key, value]) => ({ key: value.key, value: value.value }));
  booleanOptions = Object.entries(BooleanType).map(([key, value]) => ({ key: value.key, value: value.value }));

  @Output() onSave = new EventEmitter<Attribute>();

  constructor(private fb: FormBuilder,
    private financeApi: FinanceApiService,
    private toasterService: ToasterService,
    private loadingService: LoadingService
  ) {
  }

  ngOnInit() {
    this.editMode = !!this.attribute;
    this.initForm();
    this.patchForm();
  }

  private initForm() {
    this.attributeForm = this.fb.group({
      name: [null, Validators.required],
      symbol: [{ value: null, disabled: this.attribute?.id }, Validators.required],
      description: [null],
      dataType: [{ value: null, disabled: this.attribute?.id }, selectValidator()],
      defaultValue: [null],
      mandatory: [false],
    });
  }

  async saveForm() {
    this.attributeForm.markAllAsTouched();
    if (!this.attributeForm.valid) return;
    const isValidSymbol = await this.validateSymbol();
    if (!isValidSymbol) return;
    const attributeData = this.updateAttributeFromForm();
    this.onSave.emit(attributeData);
  }

  patchForm() {
    if (this.editMode) {
      const value = Array.isArray(this.attribute.defaultValues) && this.attribute.defaultValues.length > 0
                    ? this.formatValue(this.attribute.defaultValues[0]?.value, this.attribute?.dataType)
                    : null;
      console.log('value: ', value);
      this.attributeForm.patchValue({
        ...this.attribute,
        defaultValue: value,
      });
    }
  }

  formatValue(value: string, dataType?: string): any {
    if (!value) return value;
    if (dataType === 'BOOLEAN') {
      return Boolean(value);
    }
    return value;
  }

  async validateSymbol(): Promise<boolean> {
    if (this.attribute?.id) return true;
    
    this.loadingService.show();
    try {
      const res = await firstValueFrom(
        this.financeApi.isValidSymbol(this.attributeForm.get('symbol')?.value)
      );
      const isValid = res.data;
      if (!isValid) {
        this.toasterService.error('Symbol already exists');
      }
      return isValid;
    } catch (err: any) {
      this.toasterService.error(err.error?.errorDesc || 'Error validating symbol');
      return false;
    } finally {
      this.loadingService.hide();
    }
  }

  // createAttributeFromForm(): Attribute {
  //   const formValue = this.attributeForm.value;
  //   return {
  //     ...formValue,
  //     id: this.attribute?.id,
  //     defaultValues: formValue.defaultValue != null ? [{ value: formValue.defaultValue }] : null,
  //   };
  // }

  updateAttributeFromForm(): Attribute {
    const formValue = this.attributeForm.value;
    const defaultValues = formValue.defaultValue != null ? [{ value: formValue.defaultValue }] : null;
  
    if (this.attribute) {
      Object.assign(this.attribute, { ...formValue, defaultValues });
      return this.attribute;
    }
  
    return { ...formValue, defaultValues };
  }
}
